import api from '../api';

const guardianViewingsService = {
  // GET /api/spaces/my-confirmations - Laravel: SpacesController@myConfirmations
  getViewingStatus: async () => {
    try {
      const response = await api.get('/spaces/my-confirmations');

      if (response.data?.success) {
        // Return status counts from backend
        return {
          success: true,
          data: response.data.statusCounts || {
            all: 0, upcoming: 0, past: 0, going: 0, attended: 0, notAttended: 0
          },
          source: 'database'
        };
      }

      throw new Error('Failed to get viewing status');
    } catch (error) {
      console.error('❌ [SERVICE] Error fetching viewing status:', error);
      throw error;
    }
  },

  // GET /api/spaces/my-confirmations with filtering - Laravel DataTable equivalent
  getViewingSchedule: async (params) => {
    try {
      const response = await api.get('/spaces/my-confirmations');

      if (response.data?.success) {
        let confirmations = response.data.data || [];

        // Filter by status_id (Laravel DataTable filtering)
        const statusId = params.status_id || '999'; // 999 = All

        if (statusId !== '999') {
          const now = new Date();
          const todayMidnight = new Date();
          todayMidnight.setHours(0, 0, 0, 0);

          confirmations = confirmations.filter(conf => {
            const viewing = conf.propertyViewing;
            if (!viewing) return false;

            const viewingDate = new Date(viewing.date);

            // Status filtering (Laravel logic)
            if (statusId === '100') { // Upcoming
              return viewingDate >= todayMidnight;
            } else if (statusId === '101') { // Past
              return viewingDate < todayMidnight;
            } else if (statusId === '0') { // Going
              return conf.status_id === 0;
            } else if (statusId === '1') { // Attended
              return conf.status_id === 1;
            } else if (statusId === '2') { // Not Attended
              return conf.status_id === 2;
            }

            return true;
          });
        }

        // Search filtering (Laravel DataTable search)
        if (params.search?.value) {
          const searchTerm = params.search.value.toLowerCase();
          confirmations = confirmations.filter(conf => {
            const property = conf.propertyViewing?.property;
            if (!property) return false;

            return (
              property.name?.toLowerCase().includes(searchTerm) ||
              property.postcode?.toLowerCase().includes(searchTerm)
            );
          });
        }

        // Format for frontend display
        const formattedData = confirmations.map(conf => {
          const viewing = conf.propertyViewing;
          const property = viewing?.property;

          if (!viewing || !property) return null;

          const viewingDate = new Date(viewing.date);
          const formattedDate = viewingDate.toLocaleDateString('en-GB', {
            timeZone: 'Europe/London',
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });

          // Status names (Laravel config)
          const statusNames = {
            0: 'Going',
            1: 'Attended',
            2: 'Not Attended'
          };

          return {
            id: conf.id,
            name: `<a href="/spaces/show/${property.id}" style="color: #337ab7; text-decoration: none;">${property.name || 'Unknown Property'}</a>`,
            postcode: property.postcode || '-',
            day: formattedDate,
            time_from: viewing.time_from || '-',
            time_to: viewing.time_to || '-',
            status: statusNames[conf.status_id] || 'Unknown',
            actions: `<button class="btn btn-danger btn-sm cancel-viewing" data-viewing-id="${conf.id}">Cancel</button>`
          };
        }).filter(Boolean);

        // Pagination
        const start = params.start || 0;
        const length = params.length || 30;
        const paginatedData = formattedData.slice(start, start + length);

        return {
          success: true,
          data: paginatedData,
          recordsTotal: formattedData.length,
          recordsFiltered: formattedData.length,
          source: 'database'
        };
      }

      throw new Error('Failed to get viewing schedule');
    } catch (error) {
      console.error('❌ [SERVICE] Error fetching viewing schedule:', error);
      throw error;
    }
  },

  // DELETE /api/propertyviewings/viewing/{viewingId}/cancel - Laravel compatible
  cancelViewing: async (confirmationId) => {
    try {
      const response = await api.delete(`/propertyviewings/viewing/${confirmationId}/cancel`);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Error cancelling viewing:', error);
      throw error;
    }
  },

  // POST /api/propertyviewings/viewing/{viewingId}/attend - Laravel compatible
  confirmViewing: async (confirmationId, status) => {
    try {
      const response = await api.post(`/propertyviewings/viewing/${confirmationId}/attend`, { status });
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Error confirming viewing:', error);
      throw error;
    }
  }
};

export default guardianViewingsService;
 